var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "breadcrumb" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { separator: "/" } },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v("Главная"),
          ]),
          _vm.two
            ? _c(
                "el-breadcrumb-item",
                { attrs: { to: { path: _vm.two.path } } },
                [_vm._v(_vm._s(_vm.two.name))]
              )
            : _vm._e(),
          _vm.three
            ? _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.three))])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }